




























import { createComponent, ref, inject, computed } from '@vue/composition-api'
import { BASE_MAP, BASE_MAP_NAME, MapFactoryController } from '@/lib/map'
import { MainMapControllerSymbol } from '@/symbols'
import { useMapMode } from '@/lib/useMapMode'

export default createComponent({
  name: 'SwitchMapModeButton',
  props: {
    isInSheet: {
      type: Boolean,
      default: false
    }
  },
  setup () {
    const mapModeBottomSheet = ref(false)
    const mapController = inject(MainMapControllerSymbol, ref<MapFactoryController>())

    const { currentMapMode: currentMapMode$ } = useMapMode()
    const currentMapMode = computed({
      get: () => currentMapMode$.value,
      set: (value) => {
        currentMapMode$.value = value

        mapController.value?.mapInstance.changeBaseMap(value)
        mapModeBottomSheet.value = false
      }
    })

    const mapModes = [BASE_MAP.SATELITE, BASE_MAP.OSM, BASE_MAP.TAIWAN].map(type => ({
      type,
      name: BASE_MAP_NAME[type]
    }))

    const currentMapModeName = computed(() =>
      mapModes.find((mode) => mode.type === currentMapMode.value)?.name ?? mapModes[0]?.name
    )

    return {
      mapModeBottomSheet,
      mapModes,
      currentMapMode,
      currentMapModeName
    }
  }
})
